export const createWixBaseUiEnvironmentProvider = () => {
  const {
    WixBaseUiEnvironmentProvider,
  } = require('@wix/wix-base-ui/lib/esm/util/WixBaseUiEnvironment/WixBaseUiEnvironment');
  return WixBaseUiEnvironmentProvider;
};
